export const formIdList = {
    studentProfile : "ik2iLRemuBus",
    teacherProfile : "uL3ChT3ubHus",
    deepResearch : "fLQtVrEXaLus",
    weekSchedule : "tUnvGhvNP4us"
}